module.exports = __webpack_public_path__ + "static/media/Ersoy_Efe_Uruk_CV.2e936722.pdf";